<template>
  <common-panel
    id="home-store-warning"
    class="store-warning-container"
    title="店铺提醒" v-if="cmsConfig"
    >
    <div class="store-warning-column">
      <span class="tradeTitle">{{cmsConfig.remind[0].name}}</span>
      <div class="trade-info">
        <div class="info-top" >
          <div class="trade-item" v-for="(topItem, topIndex) in spliceList" :key="topIndex + '_top'" @click="itemClickHandler(topItem)">
            <div class="trade-num">
              <store-warning-num :num="remind[topItem.dataIndex]" :fontSize="'20px'"></store-warning-num>
            </div>
            <div class="trade-name">{{topItem.name}}</div>
          </div>
          <!-- 新接入待办系统的 —— 待处理违规单-->
          <div class="trade-item" v-if="!isUggSell" @click="openHandleViolate">
            <div class="trade-num">
              <store-warning-num :num="handleviolate[0].taskTotalCount" :fontSize="'20px'"></store-warning-num>
            </div>
            <div class="trade-name">待处理违规单</div>
          </div>
          <div class="trade-item" @click="openReadyOverCollect">
            <div class="trade-num">
              <store-warning-num :num="overCollection.readyOverDealCnt" :fontSize="'20px'"></store-warning-num>
            </div>
            <div class="trade-name">即将超期未揽件</div>
          </div>
           <div class="trade-item"  @click="openOverCollect">
            <div class="trade-num">
              <store-warning-num :num="overCollection.overDealCnt" :fontSize="'20px'"></store-warning-num>
            </div>
            <div class="trade-name">超期未揽件</div>
          </div>
        </div>
      </div>
      <div class="other-info" v-if="!isUggSell">
        <div class="category-item" v-for="(cates, cateIndex) in cmsConfig.remind.slice(1)" :key="cateIndex">
          <div class="title">{{cates.name}}</div>
          <div class="inner-items">
            <div
              v-for="(cateItem, cateItemIndex) in cates.children"
              :key="cateItemIndex" @click="itemClickHandler(cateItem)">
              <div class="item">
                <div class="cate-name">{{cateItem.name}}</div>
                <div class="cate-num">
                  <store-warning-num :num="remind[cateItem.dataIndex]"></store-warning-num>
                </div>
              </div>
              <div class="underLine"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </common-panel>
</template>

<script>
  import { mapState } from 'vuex'
  import CommonPanel from "@/components/common-panel/index"
  import StoreWarningNum from "@/components/num"
  import {cookieDate3Seconds, setCookie} from "@/utils/utils"
  import _ from 'lodash'

  export default {
    name: "store-warning",
    components: {StoreWarningNum, CommonPanel},
    computed: {
      remind() {
        return {...this.$store.state.popHome.remind, ...this.$store.state.fuwuOrderCount}
      },
      ...mapState(['cmsConfig', 'unifiedTaskSummary', 'isUggSell']),
      handleviolate() {
        return this.unifiedTaskSummary ? this.unifiedTaskSummary.filter(v => v.sceneId == 1) : ''
      },
      overCollection() {
        console.log(this.$store.state.popHome.overCollectSummary)
        return this.$store.state.popHome.overCollectSummary
      },
      spliceList() {
        let resutList = _.cloneDeep(this.cmsConfig.remind[0].children)
        if (this.isUggSell) {
          return resutList.filter(item => !item.hide4uggsell)
        } else {
          return resutList
        }
      }
    },
    created() {
      this.$store.dispatch('popHome/getMarkRemind')
      this.$store.dispatch('popHome/getShopRemind')
      this.$store.dispatch('popHome/getDealExRemind')
      this.$store.dispatch('popHome/getOverCollectSummary') // 超期未揽件
      this.$store.dispatch('popHome/getReadyOverCollectSummary') // 即将超期未揽件
      this.$store.dispatch('popHome/getPrewardPunisRemind')
      this.$store.dispatch('getFuwuOrderCount')
      
    },
    methods: {
      // 待处理违规单跳转
      openHandleViolate() {
        if (this.handleviolate.length == 0 || !this.handleviolate[0].pcUrl) return
        window.open(this.handleviolate[0].pcUrl)
      },
      openReadyOverCollect() {
        window.open('//myseller.haiziwang.com/service/overcollect/1')
      },

      openOverCollect() {
        // if (this.handleviolate.length == 0 || !this.handleviolate[0].pcUrl) return
        window.open('//myseller.haiziwang.com/service/overcollect/2')
      },
      itemClickHandler (cateItem) {
        let {link, cookies} = cateItem
        if(link && link !== '' && cateItem.target === '_blank'){
          window.open(link)
          return
        }
        if (link && link !== '') {
          this.$emit('itemClick', link)
        }
        // 针对需要塞入cookie的操作
        //返回当前日期yyyy:mm:dd
        const setDefaultDate = (dayShift) => {
          const myDate = new Date();
          let month = myDate.getMonth() + 1;
          let day = myDate.getDate() + dayShift;
          month = (month.toString().length === 1) ? ("0" + month) : month;
          day = (day.toString().length === 1) ? ("0" + day) : day;
          const result = myDate.getFullYear() + '-' + month + '-' + day; //当前日期
          return result;
        }

        if (cookies && cookies !== '') {
          cookies.split(';').forEach((v) => {
            const splits = v.split(',')
            const key = splits[0]
            const value = splits[1]
            if (key === 'isDealState') {
              setCookie(key, value, { expires: cookieDate3Seconds() })
            } else {
              setCookie(key, setDefaultDate(value * 1), { expires: cookieDate3Seconds() })
            }
          })
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.store-warning-column {
  display: flex;
  flex-direction: column;
  .tradeTitle {
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    font-size: 14px;
    color: #333333;
    letter-spacing: 0;
    line-height: 19px;
  }
  .trade-info {
    margin-top: 10px;
    height: auto;
    background: #f7f7f7;
    padding: 20px 20px 20px 20px;
    display: flex;
    flex-direction: column;
    .info-top {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .trade-item {
        width: 20%;
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-bottom: 10px;
        cursor: pointer;
        font-family: MicrosoftYaHei;
        .trade-name {
          margin-top: 10px;
          font-size: 13px;
          color: #666666;
        }
      }
    }
    /* .info-top:last-child {
      margin-top: 10px;
    } */
  }

  .other-info {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    .category-item {
      display: flex;
      flex-direction: column;
      width: 28%;
      .title {
        font-weight: bold;
        margin-bottom: 10px;
      }
      .inner-items {
        overflow: auto;
        height: 156px;
        .item {
          width: 95%;
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          cursor: pointer;
          font-family: MicrosoftYaHei;
          font-size: 13px;
          line-height: 17px;
          .cate-name {
            color: #666666;
          }
        }
        .underLine {
          width: 95%;
          margin-bottom: 10px;
          border: 1px dotted #eeeeee;
        }
      }
      .inner-items::-webkit-scrollbar {
        width: 4px;
      }
      .inner-items::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background: #C3C3C3;
      }
      .inner-items::-webkit-scrollbar-track {
        border-radius: 4px;
        background: #f0f0f0;
      }
    }

  }
}
</style>
